import { useEffect } from "react";
import { upsertQueryParam } from "common/utils/browser";
import Tile from "./Tile.vue";
import { useDtfStore } from "../store";
import "./Variants.scss";
import { renderList } from "common/vue/render-list";
import { cn } from "tailwind-variants";

export default function Variants(props) {
  const { ...restProps } = props;
  const dtfStore = useDtfStore();

  function gangSheetBuilderVariants() {
    return dtfStore.gangSheetBuilderVariants;
  }

  function gangSheetBuilderSettings() {
    return dtfStore.gangSheetBuilderSettings;
  }

  function updateGangSheetBuilderSettings(...args) {
    return dtfStore.updateGangSheetBuilderSettings(...args);
  }

  function setProductSlug(...args) {
    return dtfStore.setProductSlug(...args);
  }

  function setVariantId(...args) {
    return dtfStore.setVariantId(...args);
  }

  function updatePdpDates(...args) {
    return dtfStore.updatePdpDates(...args);
  }

  function updateBulkTable(...args) {
    return dtfStore.updateBulkTable(...args);
  }

  function updateCarouselImage(...args) {
    return dtfStore.updateCarouselImage(...args);
  }

  function handleTileSelected(value) {
    const variantObj = Object.values(gangSheetBuilderVariants()).find(
      variant => variant.variant_id === value
    );
    setVariantId(value);
    updateGangSheetBuilderSettings({
      variantId: value
    });
    setProductSlug(variantObj.product_slug);
    updatePdpDates();
    updateBulkTable();
    updateCarouselImage({
      variantId: value
    });
    upsertQueryParam("v", variantObj.catalog_number, {
      redirect: false,
      replace: false
    });
  }

  function isSelected(variantId) {
    return gangSheetBuilderSettings().variantId === variantId;
  }

  useEffect(() => {
    updateCarouselImage({
      variantId: gangSheetBuilderSettings().variantId
    });
  }, []);

  return (
    <div {...restProps} className={cn("gang-sheet-builder-variants")}>
      <span className={cn("gang-sheet-builder-variants__title")}>Select variant</span>
      <div className={cn("gang-sheet-builder-variants__tiles")}>
        {renderList(gangSheetBuilderVariants(), (variant, label) => (
          <Tile
            key={variant.variant_id}
            value={{
              label,
              value: variant.variant_id
            }}
            isSelected={isSelected(variant.variant_id)}
            onTileSelected={handleTileSelected}
            data-testid="tile"
          />
        ))}
      </div>
    </div>
  );
}
